module.exports = __webpack_public_path__ + "static/media/35_B.ef28e165.png";